import { render } from "./RegisterCompany.vue?vue&type=template&id=6e22886c&scoped=true"
import script from "./RegisterCompany.vue?vue&type=script&lang=js"
export * from "./RegisterCompany.vue?vue&type=script&lang=js"

import "./RegisterCompany.vue?vue&type=style&index=0&id=6e22886c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e22886c"]])

export default __exports__